import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Manufacturing_ds_get_outbound_orders_with_manufacturing_finished_productService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { material_id?: number, project_id?: number }): 
  Promise<{ result: { Id?: number, LookupCode?: string, OrderStatusId?: number, ProjectId?: number, OrderLines?: { OrderId?: number, Amount?: number, LicensePlateId?: number, LotId?: number, MaterialId?: number, PackagedAmount?: number }[] }[] }> 
  {
    let url = `${environment.backendUrl}api/Manufacturing/datasources/ds_get_outbound_orders_with_manufacturing_finished_product/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { material_id?: number, project_id?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, LookupCode?: string, OrderStatusId?: number, ProjectId?: number, OrderLines?: { OrderId?: number, Amount?: number, LicensePlateId?: number, LotId?: number, MaterialId?: number, PackagedAmount?: number }[] }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/Manufacturing/datasources/ds_get_outbound_orders_with_manufacturing_finished_product/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { material_id?: number, project_id?: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, LookupCode?: string, OrderStatusId?: number, ProjectId?: number, OrderLines?: { OrderId?: number, Amount?: number, LicensePlateId?: number, LotId?: number, MaterialId?: number, PackagedAmount?: number }[] }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Manufacturing/datasources/ds_get_outbound_orders_with_manufacturing_finished_product/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      material_id?: number, project_id?: number    }) {
      return false;
    }
}
